import {
  Container,
  Navbar,
  AppContainer,
  NavbarLabel,
  NavbarTitle,
  NavbarRightDiv,
  Banner,
  BannerShadow,
  AvatarContainerMini,
  ContainerBodyMini,
  ContainerEyes,
  ContainerMouthMini,
  AvatarContainerDiv,
  BannerText,
  FAQ,
  NavbarButton,
  ErrorModalTitle,
  ErrorModalContainer,
  ErrorModalSubtitle,
  ErrorModalButton,
  ErrorModalTextContainer,
  FeedbackIcon,
  FeedbackTextareaDiv,
  FeedbackSpan,
  FeedbackButton,
  FeedbackSubmitButton,
  FeedbackCloseButton,
  FeedbackDiv,
  FeedbackTextArea,
  TourButton,
  MigrationModalContainer,
  MigrationModalTitle,
  MigrationModalText,
  MigrationModalLink,
  MigrationModalDate,
  MigrationModalButton,
} from "./homeStyled";
import ReportPanel from "./ReportsPanel";
import TalkingPagey from "./TalkingPagey";
import { useEffect, useState } from "react";
import { apiRequest, apiRoutes } from "../../services";
import logo from "../../assets/PagerDuty-WhiteRGB.svg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSignOut,
  faQuestionCircle,
  faExclamationTriangle,
} from "@fortawesome/free-solid-svg-icons";
import Body from "../../assets/SVGs/Body/body";
import Eyes1 from "../../assets/SVGs/Eyes/eyes1";
import Mouth1 from "../../assets/SVGs/Mouth/mouth1";
import { Modal, Questions, FeedBack } from "../../components";
import Paths from "../../paths";
import { apiErrorSubject } from "../../subjects/subjects";
import TerribleFace from "../../assets/SVGs/Faces/terribleFace";
import BadFace from "../../assets/SVGs/Faces/badFace";
import OkayFace from "../../assets/SVGs/Faces/okayFace";
import GoodFace from "../../assets/SVGs/Faces/goodFace";
import AmazingFace from "../../assets/SVGs/Faces/amazingFace";
import Like from "../../assets/SVGs/like";
import ReactJoyride from "react-joyride";
import pagey from "../../assets/pagey.png";

interface UserInfo {
  name: string;
  email: string;
  role: string;
  subdomain: string;
  domain: string;
}

export default function Home() {
  const pathname = window.location.pathname;
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [runTour, setRunTour] = useState<boolean>(false);
  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const [errorModalOpen, setErrorModalOpen] = useState<boolean>(false);
  const [userInfo, setUserInfo] = useState<null | UserInfo>(null);
  const [questionsArray, setQuestionsArray] = useState<any>([]);
  const [apiText, setApiText] = useState<string>("");
  const [feedbackRating, setFeedbackRating] = useState<number | null>(null);
  const [feedbackDescription, setFeedbackDescription] = useState("");
  const [feedBackState, setFeedBackState] = useState(false);
  const [feedbackModalOpen, setFeedbackModalOpen] = useState<boolean>(false);
  const [migrationModalOpen, setMigrationModalOpen] = useState<boolean>(false);

  useEffect(() => {
    apiErrorSubject.subscribe((text: any) => {
      setApiText(text);
      setErrorModalOpen(true);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    fetch_UserInfo();
    fetch_RunTour();
    fetch_Questions();
  }, []);

  useEffect(() => {
    // Mostrar modal de migración a todos los usuarios
    if (userInfo) {
      setMigrationModalOpen(true);
    }
  }, [userInfo]);

  const closeMigrationModal = () => {
    setMigrationModalOpen(false);
  };

  const fetch_Questions = async () => {
    setIsLoading(true);
    const [error, res] = await apiRequest({
      method: "get",
      url: apiRoutes.FAQ,
    });
    if (res) {
      setQuestionsArray(res);
    }
  };

  const fetch_UserInfo = async () => {
    setIsLoading(true);
    const [error, res] = await apiRequest({
      method: "get",
      url: apiRoutes.userSessionInfo,
    });
    if (res) {
      setUserInfo({ ...res, domain: extractEmailDomain(res.email) });
    } else {
      console.log("err", error);
      window.location.replace("/unauthorized");
    }
    setIsLoading(false);
  };

  const fetch_RunTour = async () => {
    setIsLoading(true);
    const [error, res] = await apiRequest({
      method: "get",
      url: apiRoutes.tour,
    });
    if (!res || (res && res === "active")) {
      setRunTour(true);
    }
    setIsLoading(false);
  };

  const closeTour4Ever = async () => {
    setRunTour(false);
    const [error, res] = await apiRequest({
      method: "post",
      url: apiRoutes.tour,
      data: {
        status: "inactive",
      },
    });
  };

  const extractEmailDomain = (email: string) => {
    const atSymbolIndex = email.indexOf("@");
    const dotSymbolIndex = email.indexOf(".");

    if (atSymbolIndex === -1 || dotSymbolIndex === -1) {
      console.log("Invalid email address");
      return "";
    }

    return email.substring(atSymbolIndex + 1, dotSymbolIndex);
  };

  const logout = async () => {
    setIsLoading(true);
    const [error, data] = await apiRequest({
      method: "put",
      url: `${apiRoutes.login}`,
    });
    if (data) {
      localStorage.removeItem("token");
      window.location.replace(Paths.Logout);
    } else {
      apiErrorSubject.next(
        "We have a problem when trying to log you out, please try again."
      );
    }
    setIsLoading(false);
  };

  const closeFeedbackButton = async () => {
    setFeedbackModalOpen(false);
    setFeedbackDescription("");
    setFeedbackRating(null);
  };

  const submitFeedbackButton = async () => {
    setFeedBackState(true);
    await apiRequest({
      method: "post",
      url: apiRoutes.userFeedback,
      data: {
        comments: feedbackDescription,
        rating: feedbackRating,
        page_reference: feedbackNameLiteral.hasOwnProperty(pathname)
          ? feedbackNameLiteral[pathname]()
          : "Portal",
        pathname,
      },
    });
    setTimeout(() => {
      setFeedBackState(false);
      setFeedbackModalOpen(false);
      setFeedbackDescription("");
      setFeedbackRating(null);
    }, 4000);
  };

  const feedbackNameLiteral: any = {
    "/": () => "CSG Premium Services Report Marketplace App",
    "/home": () => "CSG Premium Services Report Marketplace App",
  };

  const tourSteps = [
    {
      target: "body",
      content: (
        <div>
          <h2>
            Welcome to{" "}
            {userInfo
              ? userInfo.domain.charAt(0).toUpperCase() +
              userInfo.domain.slice(1)
              : ""}{" "}
            Premium Service Report Marketplace
          </h2>
          <img style={{ width: "230px" }} src={pagey} alt="pagey" />
          <TourButton onClick={() => closeTour4Ever()}>Close and don´t show again</TourButton>
        </div>
      ),
      placement: "center" as "center",
    },
    {
      target: "#MultiSelectDropdownId",
      content:
        "In this dropdown you can select one or multiple domains, which will be used to prepare your reports.",
    },
    {
      target: "#FiltersButtonId",
      content:
        "From the gear button you can open more filters for your reports.",
    },
    {
      target: "#ReportPanelId",
      content: "All the reports you have available will appear here.",
    },
    {
      target: "#ClockId0",
      content:
        "Icons like this will appear in your reports, they show what filters apply to them and you can always click on them to know the details of the filters applied.",
    },
    {
      target: "#QuestionId0",
      content:
        "By clicking on this icon you will be able to see the description of the content of the report.",
    },
    {
      target: "#CustomFields0",
      content:
        "From here you can select the fields you want to appear in your report, as well as their order by drag and drop over the rows.",
    },
    {
      target: "#Coin0",
      content:
        "This show the number of Pagey tokens it costs to download this report.",
    },
    {
      target: "#Download0",
      content:
        "You simply have to click here to download your report, and you can download multiple at the same time!",
    },
    {
      target: "#FAQId",
      content:
        "If you still have questions, we try to answer the most frequent ones from here!",
    },
    {
      target: "#FeedbackId",
      content: <div style={{ display: 'flex', flexDirection: "column", rowGap: '10px' }}>
        <label>If you have any suggestion please send it to us from here, we always try to improve and give you the best service!</label>
        <TourButton onClick={() => closeTour4Ever()}>Close and don´t show again</TourButton>
      </div>,
    },
  ];

  return (
    <>
      <Container>
        <ReactJoyride
          continuous={true}
          showProgress={true}
          showSkipButton={true}
          steps={tourSteps}
          run={runTour}
          styles={{
            options: {
              arrowColor: "#e3ffeb",
              primaryColor: "rgb(0, 90, 36)",
              textColor: "#004a14",
              zIndex: 1000,
            },
          }}
        />
        <Navbar>
          <NavbarTitle>
            <img
              style={{ height: "30px", marginTop: "5px" }}
              className="logo"
              src={logo}
              alt="logo"
            ></img>
          </NavbarTitle>
          <NavbarRightDiv>
            <NavbarLabel>
              Hello, {(userInfo && userInfo.name) || ""}
            </NavbarLabel>
            <FeedbackIcon
              id="FeedbackId"
              onClick={() => setFeedbackModalOpen(true)}
              className={"center-corner"}
            >
              <Like scale={0.025} />
            </FeedbackIcon>
            <NavbarButton onClick={() => logout()}>
              Sign Out{" "}
              <FontAwesomeIcon
                style={{
                  cursor: "pointer",
                  color: "#06ac38",
                  fontSize: "16px",
                  marginLeft: "10px",
                }}
                icon={faSignOut}
              />
            </NavbarButton>
          </NavbarRightDiv>
        </Navbar>
        <AppContainer>
          <Banner>
            <AvatarContainerDiv>
              <AvatarContainerMini>
                <ContainerBodyMini>
                  <Body
                    className=""
                    scale="0.2"
                    fillBody="#5aa04b"
                    fillTop={"#5aa04b"}
                    fillLines="#000000"
                  />
                </ContainerBodyMini>
                <ContainerEyes>
                  <Eyes1
                    className=""
                    fillEyes="#000000"
                    scale="0.2"
                    fillEyebrows="#000000"
                  />
                </ContainerEyes>
                <ContainerMouthMini>
                  <Mouth1
                    scale="0.2"
                    mouthColorTop="#a90000"
                    mouthColorBottom="#ff0000"
                    className="normalMouthClass"
                  />
                </ContainerMouthMini>
              </AvatarContainerMini>
            </AvatarContainerDiv>
            <BannerText>
              {`CSG Innovations - Premium Services Report Marketplace - ${userInfo ? userInfo.domain : ""
                }`.toUpperCase()}
            </BannerText>
          </Banner>
          <BannerShadow></BannerShadow>
          <ReportPanel
            domain={
              userInfo
                ? userInfo.domain.charAt(0).toUpperCase() +
                userInfo.domain.slice(1)
                : ""
            }
          />
          {questionsArray.length > 0 && (
            <FAQ onClick={() => setModalOpen(true)}>
              Frequently Asked Questions
              <FontAwesomeIcon
                id="FAQId"
                style={{
                  cursor: "pointer",
                  color: "#06ac38",
                  fontSize: "16px",
                  marginLeft: "10px",
                }}
                icon={faQuestionCircle}
              />
            </FAQ>
          )}
          <TalkingPagey />
        </AppContainer>
      </Container>
      <Modal
        show={modalOpen}
        title="FAQ"
        handleClose={() => setModalOpen(!modalOpen)}
        modalFitContent
        dontShowCloseButton={false}
      >
        <Questions questionsArray={questionsArray} />
      </Modal>
      <Modal
        show={errorModalOpen}
        title=""
        handleClose={() => setErrorModalOpen(!errorModalOpen)}
        modalFitContent
        dontShowCloseButton={false}
      >
        <ErrorModalContainer>
          <FontAwesomeIcon
            style={{
              color: "rgb(248, 36, 49)",
              fontSize: "120px",
            }}
            icon={faExclamationTriangle}
          />
          <ErrorModalTextContainer>
            <ErrorModalTitle>Oops! Something Went Wrong.</ErrorModalTitle>
            <ErrorModalSubtitle>{apiText}</ErrorModalSubtitle>
          </ErrorModalTextContainer>
          <ErrorModalButton onClick={() => setErrorModalOpen(!errorModalOpen)}>
            Close
          </ErrorModalButton>
        </ErrorModalContainer>
      </Modal>
      <Modal
        show={feedbackModalOpen}
        title="Feedback"
        handleClose={() => closeFeedbackButton()}
        modalFitContent
      >
        {feedBackState ? (
          <FeedBack />
        ) : (
          <FeedbackDiv>
            <label>
              How would you rate your experiences with the{" "}
              <FeedbackSpan>
                {feedbackNameLiteral.hasOwnProperty(pathname)
                  ? feedbackNameLiteral[pathname]()
                  : "Dashboard"}
              </FeedbackSpan>
              ?
            </label>
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "center",
              }}
            >
              <FeedbackButton
                onClick={() => setFeedbackRating(1)}
                style={
                  feedbackRating === 1
                    ? {
                      border: "1px solid rgb(6, 172, 56)",
                      color: "rgb(6, 172, 56)",
                    }
                    : {}
                }
              >
                <TerribleFace scale="0.2" />
                Terrible
              </FeedbackButton>
              <FeedbackButton
                onClick={() => setFeedbackRating(2)}
                style={
                  feedbackRating === 2
                    ? {
                      border: "1px solid rgb(6, 172, 56)",
                      color: "rgb(6, 172, 56)",
                    }
                    : {}
                }
              >
                <BadFace scale="0.2" />
                Bad
              </FeedbackButton>
              <FeedbackButton
                onClick={() => setFeedbackRating(3)}
                style={
                  feedbackRating === 3
                    ? {
                      border: "1px solid rgb(6, 172, 56)",
                      color: "rgb(6, 172, 56)",
                    }
                    : {}
                }
              >
                <OkayFace scale="0.2" />
                Okay
              </FeedbackButton>
              <FeedbackButton
                onClick={() => setFeedbackRating(4)}
                style={
                  feedbackRating === 4
                    ? {
                      border: "1px solid rgb(6, 172, 56)",
                      color: "rgb(6, 172, 56)",
                    }
                    : {}
                }
              >
                <GoodFace scale="0.2" />
                Good
              </FeedbackButton>
              <FeedbackButton
                onClick={() => setFeedbackRating(5)}
                style={
                  feedbackRating === 5
                    ? {
                      border: "1px solid rgb(6, 172, 56)",
                      color: "rgb(6, 172, 56)",
                    }
                    : {}
                }
              >
                <AmazingFace scale="0.2" />
                Amazing
              </FeedbackButton>
            </div>
            <FeedbackTextareaDiv>
              <label>
                Do you have any feedback or comments on improving the{" "}
                <FeedbackSpan>
                  {feedbackNameLiteral.hasOwnProperty(pathname)
                    ? feedbackNameLiteral[pathname]()
                    : "Dashboard"}
                </FeedbackSpan>
                ?
              </label>
              <FeedbackTextArea
                value={feedbackDescription}
                onChange={(e: any) => setFeedbackDescription(e.target.value)}
              />
            </FeedbackTextareaDiv>
            <div>
              <FeedbackSubmitButton
                onClick={() => submitFeedbackButton()}
                disabled={!feedbackRating || !feedbackDescription}
              >
                Submit
              </FeedbackSubmitButton>
              <FeedbackCloseButton onClick={() => closeFeedbackButton()}>
                Cancel
              </FeedbackCloseButton>
            </div>
          </FeedbackDiv>
        )}
      </Modal>
      <Modal
        show={migrationModalOpen}
        title="Important Announcement"
        handleClose={() => closeMigrationModal()}
        modalFitContent
        dontShowCloseButton={false}
      >
        <MigrationModalContainer>
          <MigrationModalTitle>
            Marketplace 2.0 is coming!
          </MigrationModalTitle>
          <MigrationModalText>
            We're excited to announce that the Premium Services Report Marketplace is being upgraded to version 2.0!
            This new version will bring improved performance, enhanced features, and a better user experience.
          </MigrationModalText>
          <MigrationModalText>
            The new marketplace will be available at:
          </MigrationModalText>
          <MigrationModalLink
            href="https://portal.innovation.csg.pagerduty.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://portal.innovation.csg.pagerduty.com
          </MigrationModalLink>
          <MigrationModalDate>
            Available from: March 12, 2026
          </MigrationModalDate>
          <MigrationModalButton onClick={() => closeMigrationModal()}>
            Got it!
          </MigrationModalButton>
        </MigrationModalContainer>
      </Modal>
    </>
  );
}
